/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WhatsappTemplatesRouteImport } from './routes/whatsapp-templates'
import { Route as WhatsappOptoutsRouteImport } from './routes/whatsapp-optouts'
import { Route as WhatsappFlowResponsesRouteImport } from './routes/whatsapp-flow-responses'
import { Route as WhatsappCampaignsRouteImport } from './routes/whatsapp-campaigns'
import { Route as WhatsappAudiencesRouteImport } from './routes/whatsapp-audiences'
import { Route as WhatsappRouteImport } from './routes/whatsapp'
import { Route as UploadRouteImport } from './routes/upload'
import { Route as TreatmentsRouteImport } from './routes/treatments'
import { Route as SupportRouteImport } from './routes/support'
import { Route as StockRouteImport } from './routes/stock'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RosterRouteImport } from './routes/roster'
import { Route as RedemptionRouteImport } from './routes/redemption'
import { Route as PatientsRouteImport } from './routes/patients'
import { Route as PackagesRouteImport } from './routes/packages'
import { Route as LoginRouteImport } from './routes/login'
import { Route as KnowledgeBaseRouteImport } from './routes/knowledge-base'
import { Route as InvoicesRouteImport } from './routes/invoices'
import { Route as FollowUpsRouteImport } from './routes/follow-ups'
import { Route as ChatRouteImport } from './routes/chat'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as CalendarRouteImport } from './routes/calendar'
import { Route as AppointmentsRouteImport } from './routes/appointments'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WhatsappTemplatesNewRouteImport } from './routes/whatsapp-templates_.new'
import { Route as WhatsappCampaignsNewRouteImport } from './routes/whatsapp-campaigns_.new'
import { Route as WhatsappCampaignsIdRouteImport } from './routes/whatsapp-campaigns_.$id'
import { Route as WhatsappAudiencesNewRouteImport } from './routes/whatsapp-audiences_.new'
import { Route as PatientsIdRouteImport } from './routes/patients_.$id'
import { Route as InvoicesIdRouteImport } from './routes/invoices_.$id'

const WhatsappTemplatesRoute = WhatsappTemplatesRouteImport.update({
  id: '/whatsapp-templates',
  path: '/whatsapp-templates',
  getParentRoute: () => rootRouteImport,
} as any)
const WhatsappOptoutsRoute = WhatsappOptoutsRouteImport.update({
  id: '/whatsapp-optouts',
  path: '/whatsapp-optouts',
  getParentRoute: () => rootRouteImport,
} as any)
const WhatsappFlowResponsesRoute = WhatsappFlowResponsesRouteImport.update({
  id: '/whatsapp-flow-responses',
  path: '/whatsapp-flow-responses',
  getParentRoute: () => rootRouteImport,
} as any)
const WhatsappCampaignsRoute = WhatsappCampaignsRouteImport.update({
  id: '/whatsapp-campaigns',
  path: '/whatsapp-campaigns',
  getParentRoute: () => rootRouteImport,
} as any)
const WhatsappAudiencesRoute = WhatsappAudiencesRouteImport.update({
  id: '/whatsapp-audiences',
  path: '/whatsapp-audiences',
  getParentRoute: () => rootRouteImport,
} as any)
const WhatsappRoute = WhatsappRouteImport.update({
  id: '/whatsapp',
  path: '/whatsapp',
  getParentRoute: () => rootRouteImport,
} as any)
const UploadRoute = UploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => rootRouteImport,
} as any)
const TreatmentsRoute = TreatmentsRouteImport.update({
  id: '/treatments',
  path: '/treatments',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const StockRoute = StockRouteImport.update({
  id: '/stock',
  path: '/stock',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RosterRoute = RosterRouteImport.update({
  id: '/roster',
  path: '/roster',
  getParentRoute: () => rootRouteImport,
} as any)
const RedemptionRoute = RedemptionRouteImport.update({
  id: '/redemption',
  path: '/redemption',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsRoute = PatientsRouteImport.update({
  id: '/patients',
  path: '/patients',
  getParentRoute: () => rootRouteImport,
} as any)
const PackagesRoute = PackagesRouteImport.update({
  id: '/packages',
  path: '/packages',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const KnowledgeBaseRoute = KnowledgeBaseRouteImport.update({
  id: '/knowledge-base',
  path: '/knowledge-base',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesRoute = InvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => rootRouteImport,
} as any)
const FollowUpsRoute = FollowUpsRouteImport.update({
  id: '/follow-ups',
  path: '/follow-ups',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoute = ChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarRoute = CalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const AppointmentsRoute = AppointmentsRouteImport.update({
  id: '/appointments',
  path: '/appointments',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WhatsappTemplatesNewRoute = WhatsappTemplatesNewRouteImport.update({
  id: '/whatsapp-templates_/new',
  path: '/whatsapp-templates/new',
  getParentRoute: () => rootRouteImport,
} as any)
const WhatsappCampaignsNewRoute = WhatsappCampaignsNewRouteImport.update({
  id: '/whatsapp-campaigns_/new',
  path: '/whatsapp-campaigns/new',
  getParentRoute: () => rootRouteImport,
} as any)
const WhatsappCampaignsIdRoute = WhatsappCampaignsIdRouteImport.update({
  id: '/whatsapp-campaigns_/$id',
  path: '/whatsapp-campaigns/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const WhatsappAudiencesNewRoute = WhatsappAudiencesNewRouteImport.update({
  id: '/whatsapp-audiences_/new',
  path: '/whatsapp-audiences/new',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsIdRoute = PatientsIdRouteImport.update({
  id: '/patients_/$id',
  path: '/patients/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesIdRoute = InvoicesIdRouteImport.update({
  id: '/invoices_/$id',
  path: '/invoices/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/appointments': typeof AppointmentsRoute
  '/calendar': typeof CalendarRoute
  '/change-password': typeof ChangePasswordRoute
  '/chat': typeof ChatRoute
  '/follow-ups': typeof FollowUpsRoute
  '/invoices': typeof InvoicesRoute
  '/knowledge-base': typeof KnowledgeBaseRoute
  '/login': typeof LoginRoute
  '/packages': typeof PackagesRoute
  '/patients': typeof PatientsRoute
  '/redemption': typeof RedemptionRoute
  '/roster': typeof RosterRoute
  '/settings': typeof SettingsRoute
  '/stock': typeof StockRoute
  '/support': typeof SupportRoute
  '/treatments': typeof TreatmentsRoute
  '/upload': typeof UploadRoute
  '/whatsapp': typeof WhatsappRoute
  '/whatsapp-audiences': typeof WhatsappAudiencesRoute
  '/whatsapp-campaigns': typeof WhatsappCampaignsRoute
  '/whatsapp-flow-responses': typeof WhatsappFlowResponsesRoute
  '/whatsapp-optouts': typeof WhatsappOptoutsRoute
  '/whatsapp-templates': typeof WhatsappTemplatesRoute
  '/invoices/$id': typeof InvoicesIdRoute
  '/patients/$id': typeof PatientsIdRoute
  '/whatsapp-audiences/new': typeof WhatsappAudiencesNewRoute
  '/whatsapp-campaigns/$id': typeof WhatsappCampaignsIdRoute
  '/whatsapp-campaigns/new': typeof WhatsappCampaignsNewRoute
  '/whatsapp-templates/new': typeof WhatsappTemplatesNewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/appointments': typeof AppointmentsRoute
  '/calendar': typeof CalendarRoute
  '/change-password': typeof ChangePasswordRoute
  '/chat': typeof ChatRoute
  '/follow-ups': typeof FollowUpsRoute
  '/invoices': typeof InvoicesRoute
  '/knowledge-base': typeof KnowledgeBaseRoute
  '/login': typeof LoginRoute
  '/packages': typeof PackagesRoute
  '/patients': typeof PatientsRoute
  '/redemption': typeof RedemptionRoute
  '/roster': typeof RosterRoute
  '/settings': typeof SettingsRoute
  '/stock': typeof StockRoute
  '/support': typeof SupportRoute
  '/treatments': typeof TreatmentsRoute
  '/upload': typeof UploadRoute
  '/whatsapp': typeof WhatsappRoute
  '/whatsapp-audiences': typeof WhatsappAudiencesRoute
  '/whatsapp-campaigns': typeof WhatsappCampaignsRoute
  '/whatsapp-flow-responses': typeof WhatsappFlowResponsesRoute
  '/whatsapp-optouts': typeof WhatsappOptoutsRoute
  '/whatsapp-templates': typeof WhatsappTemplatesRoute
  '/invoices/$id': typeof InvoicesIdRoute
  '/patients/$id': typeof PatientsIdRoute
  '/whatsapp-audiences/new': typeof WhatsappAudiencesNewRoute
  '/whatsapp-campaigns/$id': typeof WhatsappCampaignsIdRoute
  '/whatsapp-campaigns/new': typeof WhatsappCampaignsNewRoute
  '/whatsapp-templates/new': typeof WhatsappTemplatesNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/appointments': typeof AppointmentsRoute
  '/calendar': typeof CalendarRoute
  '/change-password': typeof ChangePasswordRoute
  '/chat': typeof ChatRoute
  '/follow-ups': typeof FollowUpsRoute
  '/invoices': typeof InvoicesRoute
  '/knowledge-base': typeof KnowledgeBaseRoute
  '/login': typeof LoginRoute
  '/packages': typeof PackagesRoute
  '/patients': typeof PatientsRoute
  '/redemption': typeof RedemptionRoute
  '/roster': typeof RosterRoute
  '/settings': typeof SettingsRoute
  '/stock': typeof StockRoute
  '/support': typeof SupportRoute
  '/treatments': typeof TreatmentsRoute
  '/upload': typeof UploadRoute
  '/whatsapp': typeof WhatsappRoute
  '/whatsapp-audiences': typeof WhatsappAudiencesRoute
  '/whatsapp-campaigns': typeof WhatsappCampaignsRoute
  '/whatsapp-flow-responses': typeof WhatsappFlowResponsesRoute
  '/whatsapp-optouts': typeof WhatsappOptoutsRoute
  '/whatsapp-templates': typeof WhatsappTemplatesRoute
  '/invoices_/$id': typeof InvoicesIdRoute
  '/patients_/$id': typeof PatientsIdRoute
  '/whatsapp-audiences_/new': typeof WhatsappAudiencesNewRoute
  '/whatsapp-campaigns_/$id': typeof WhatsappCampaignsIdRoute
  '/whatsapp-campaigns_/new': typeof WhatsappCampaignsNewRoute
  '/whatsapp-templates_/new': typeof WhatsappTemplatesNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/analytics'
    | '/appointments'
    | '/calendar'
    | '/change-password'
    | '/chat'
    | '/follow-ups'
    | '/invoices'
    | '/knowledge-base'
    | '/login'
    | '/packages'
    | '/patients'
    | '/redemption'
    | '/roster'
    | '/settings'
    | '/stock'
    | '/support'
    | '/treatments'
    | '/upload'
    | '/whatsapp'
    | '/whatsapp-audiences'
    | '/whatsapp-campaigns'
    | '/whatsapp-flow-responses'
    | '/whatsapp-optouts'
    | '/whatsapp-templates'
    | '/invoices/$id'
    | '/patients/$id'
    | '/whatsapp-audiences/new'
    | '/whatsapp-campaigns/$id'
    | '/whatsapp-campaigns/new'
    | '/whatsapp-templates/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/analytics'
    | '/appointments'
    | '/calendar'
    | '/change-password'
    | '/chat'
    | '/follow-ups'
    | '/invoices'
    | '/knowledge-base'
    | '/login'
    | '/packages'
    | '/patients'
    | '/redemption'
    | '/roster'
    | '/settings'
    | '/stock'
    | '/support'
    | '/treatments'
    | '/upload'
    | '/whatsapp'
    | '/whatsapp-audiences'
    | '/whatsapp-campaigns'
    | '/whatsapp-flow-responses'
    | '/whatsapp-optouts'
    | '/whatsapp-templates'
    | '/invoices/$id'
    | '/patients/$id'
    | '/whatsapp-audiences/new'
    | '/whatsapp-campaigns/$id'
    | '/whatsapp-campaigns/new'
    | '/whatsapp-templates/new'
  id:
    | '__root__'
    | '/'
    | '/analytics'
    | '/appointments'
    | '/calendar'
    | '/change-password'
    | '/chat'
    | '/follow-ups'
    | '/invoices'
    | '/knowledge-base'
    | '/login'
    | '/packages'
    | '/patients'
    | '/redemption'
    | '/roster'
    | '/settings'
    | '/stock'
    | '/support'
    | '/treatments'
    | '/upload'
    | '/whatsapp'
    | '/whatsapp-audiences'
    | '/whatsapp-campaigns'
    | '/whatsapp-flow-responses'
    | '/whatsapp-optouts'
    | '/whatsapp-templates'
    | '/invoices_/$id'
    | '/patients_/$id'
    | '/whatsapp-audiences_/new'
    | '/whatsapp-campaigns_/$id'
    | '/whatsapp-campaigns_/new'
    | '/whatsapp-templates_/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AnalyticsRoute: typeof AnalyticsRoute
  AppointmentsRoute: typeof AppointmentsRoute
  CalendarRoute: typeof CalendarRoute
  ChangePasswordRoute: typeof ChangePasswordRoute
  ChatRoute: typeof ChatRoute
  FollowUpsRoute: typeof FollowUpsRoute
  InvoicesRoute: typeof InvoicesRoute
  KnowledgeBaseRoute: typeof KnowledgeBaseRoute
  LoginRoute: typeof LoginRoute
  PackagesRoute: typeof PackagesRoute
  PatientsRoute: typeof PatientsRoute
  RedemptionRoute: typeof RedemptionRoute
  RosterRoute: typeof RosterRoute
  SettingsRoute: typeof SettingsRoute
  StockRoute: typeof StockRoute
  SupportRoute: typeof SupportRoute
  TreatmentsRoute: typeof TreatmentsRoute
  UploadRoute: typeof UploadRoute
  WhatsappRoute: typeof WhatsappRoute
  WhatsappAudiencesRoute: typeof WhatsappAudiencesRoute
  WhatsappCampaignsRoute: typeof WhatsappCampaignsRoute
  WhatsappFlowResponsesRoute: typeof WhatsappFlowResponsesRoute
  WhatsappOptoutsRoute: typeof WhatsappOptoutsRoute
  WhatsappTemplatesRoute: typeof WhatsappTemplatesRoute
  InvoicesIdRoute: typeof InvoicesIdRoute
  PatientsIdRoute: typeof PatientsIdRoute
  WhatsappAudiencesNewRoute: typeof WhatsappAudiencesNewRoute
  WhatsappCampaignsIdRoute: typeof WhatsappCampaignsIdRoute
  WhatsappCampaignsNewRoute: typeof WhatsappCampaignsNewRoute
  WhatsappTemplatesNewRoute: typeof WhatsappTemplatesNewRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/whatsapp-templates': {
      id: '/whatsapp-templates'
      path: '/whatsapp-templates'
      fullPath: '/whatsapp-templates'
      preLoaderRoute: typeof WhatsappTemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/whatsapp-optouts': {
      id: '/whatsapp-optouts'
      path: '/whatsapp-optouts'
      fullPath: '/whatsapp-optouts'
      preLoaderRoute: typeof WhatsappOptoutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/whatsapp-flow-responses': {
      id: '/whatsapp-flow-responses'
      path: '/whatsapp-flow-responses'
      fullPath: '/whatsapp-flow-responses'
      preLoaderRoute: typeof WhatsappFlowResponsesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/whatsapp-campaigns': {
      id: '/whatsapp-campaigns'
      path: '/whatsapp-campaigns'
      fullPath: '/whatsapp-campaigns'
      preLoaderRoute: typeof WhatsappCampaignsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/whatsapp-audiences': {
      id: '/whatsapp-audiences'
      path: '/whatsapp-audiences'
      fullPath: '/whatsapp-audiences'
      preLoaderRoute: typeof WhatsappAudiencesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/whatsapp': {
      id: '/whatsapp'
      path: '/whatsapp'
      fullPath: '/whatsapp'
      preLoaderRoute: typeof WhatsappRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upload': {
      id: '/upload'
      path: '/upload'
      fullPath: '/upload'
      preLoaderRoute: typeof UploadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/treatments': {
      id: '/treatments'
      path: '/treatments'
      fullPath: '/treatments'
      preLoaderRoute: typeof TreatmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stock': {
      id: '/stock'
      path: '/stock'
      fullPath: '/stock'
      preLoaderRoute: typeof StockRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/roster': {
      id: '/roster'
      path: '/roster'
      fullPath: '/roster'
      preLoaderRoute: typeof RosterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/redemption': {
      id: '/redemption'
      path: '/redemption'
      fullPath: '/redemption'
      preLoaderRoute: typeof RedemptionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients': {
      id: '/patients'
      path: '/patients'
      fullPath: '/patients'
      preLoaderRoute: typeof PatientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/packages': {
      id: '/packages'
      path: '/packages'
      fullPath: '/packages'
      preLoaderRoute: typeof PackagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/knowledge-base': {
      id: '/knowledge-base'
      path: '/knowledge-base'
      fullPath: '/knowledge-base'
      preLoaderRoute: typeof KnowledgeBaseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices': {
      id: '/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof InvoicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/follow-ups': {
      id: '/follow-ups'
      path: '/follow-ups'
      fullPath: '/follow-ups'
      preLoaderRoute: typeof FollowUpsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat': {
      id: '/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar': {
      id: '/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof CalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/appointments': {
      id: '/appointments'
      path: '/appointments'
      fullPath: '/appointments'
      preLoaderRoute: typeof AppointmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/whatsapp-templates_/new': {
      id: '/whatsapp-templates_/new'
      path: '/whatsapp-templates/new'
      fullPath: '/whatsapp-templates/new'
      preLoaderRoute: typeof WhatsappTemplatesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/whatsapp-campaigns_/new': {
      id: '/whatsapp-campaigns_/new'
      path: '/whatsapp-campaigns/new'
      fullPath: '/whatsapp-campaigns/new'
      preLoaderRoute: typeof WhatsappCampaignsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/whatsapp-campaigns_/$id': {
      id: '/whatsapp-campaigns_/$id'
      path: '/whatsapp-campaigns/$id'
      fullPath: '/whatsapp-campaigns/$id'
      preLoaderRoute: typeof WhatsappCampaignsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/whatsapp-audiences_/new': {
      id: '/whatsapp-audiences_/new'
      path: '/whatsapp-audiences/new'
      fullPath: '/whatsapp-audiences/new'
      preLoaderRoute: typeof WhatsappAudiencesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients_/$id': {
      id: '/patients_/$id'
      path: '/patients/$id'
      fullPath: '/patients/$id'
      preLoaderRoute: typeof PatientsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices_/$id': {
      id: '/invoices_/$id'
      path: '/invoices/$id'
      fullPath: '/invoices/$id'
      preLoaderRoute: typeof InvoicesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AnalyticsRoute: AnalyticsRoute,
  AppointmentsRoute: AppointmentsRoute,
  CalendarRoute: CalendarRoute,
  ChangePasswordRoute: ChangePasswordRoute,
  ChatRoute: ChatRoute,
  FollowUpsRoute: FollowUpsRoute,
  InvoicesRoute: InvoicesRoute,
  KnowledgeBaseRoute: KnowledgeBaseRoute,
  LoginRoute: LoginRoute,
  PackagesRoute: PackagesRoute,
  PatientsRoute: PatientsRoute,
  RedemptionRoute: RedemptionRoute,
  RosterRoute: RosterRoute,
  SettingsRoute: SettingsRoute,
  StockRoute: StockRoute,
  SupportRoute: SupportRoute,
  TreatmentsRoute: TreatmentsRoute,
  UploadRoute: UploadRoute,
  WhatsappRoute: WhatsappRoute,
  WhatsappAudiencesRoute: WhatsappAudiencesRoute,
  WhatsappCampaignsRoute: WhatsappCampaignsRoute,
  WhatsappFlowResponsesRoute: WhatsappFlowResponsesRoute,
  WhatsappOptoutsRoute: WhatsappOptoutsRoute,
  WhatsappTemplatesRoute: WhatsappTemplatesRoute,
  InvoicesIdRoute: InvoicesIdRoute,
  PatientsIdRoute: PatientsIdRoute,
  WhatsappAudiencesNewRoute: WhatsappAudiencesNewRoute,
  WhatsappCampaignsIdRoute: WhatsappCampaignsIdRoute,
  WhatsappCampaignsNewRoute: WhatsappCampaignsNewRoute,
  WhatsappTemplatesNewRoute: WhatsappTemplatesNewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
